module.exports = __webpack_public_path__ + "static/media/resized_buttonlogo.2fe16ae9.svg";